var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"layout-header"},[_vm._t("header")],2),_c('div',{staticClass:"layout-contenter"},[_vm._t("contenter")],2),_c('div',{staticClass:"layout-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }